// import React, { useEffect, useState } from 'react';
// import { getAsync, postAsync } from '../../components/helper/axiosHelper';
// import LogsTable from './LogsTable';
// import moment from 'moment';
// import { toast } from 'react-toastify';

// const AdminLogs = () => {
//   const [loginLogs, setLoginLogs] = useState([]);
//   const [dateTo, setDateTo] = useState('');
//   const [dateFrom, setDateFrom] = useState('');
//    const [pageCount, setPageCount] = useState(1);
//   const [pageOptions, setPageOptions] = useState({
//     pageNo: 1,
//     pageSize: 20,
//   });

//   // Get Data From LocalStorage
//   console.log(EPUserId, 'EPUserId');

//   const SearchFilters = {
//     epUserID: EPUserId,
//     dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
//     dateTo: moment(dateTo).format('DD/MM/YYYY'),
//   };

//   useEffect(() => {
//     (async () => {
//       const response = await postAsync(
//         `Admin/GetLoginLogFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
//         SearchFilters,
//       );
//       setLoginLogs(response?.data);
//       console.log('response', response);
//     })();
//   }, []);

//   const changePage = async ({ selected }) => {
//     const newPage = selected + 1;
//     //setNext(selected + 1);

//     try {
//       if (dateFrom === '' && dateTo === '') {
//         // Fetch data using the updated page number
//         const response = await postAsync(`Admin/GetLoginLogFilterList/${newPage}/${pageOptions.pageSize}`, bodyGet);
//         // dispatch(setCompaignList(response.data));
//         // setPageCount(response.page);
//         // setNext(1);
//       } else {
//         // Fetch data using the updated page number
//         const response = await postAsync(
//           `Campaign/GetCampaignFilterList/${newPage}/${pageOptions.pageSize}`,
//           SearchFilters,
//         );
//         // dispatch(setCompaignList(response.data));
//         // setPageCount(response.page);
//       }
//     } catch (err) {
//       console.log(err);
//       toast.error(`${t('msg_errorDueto')}: ${err.message}`);
//     }
//   };

//   return (
//     <div className="mt-40  px-20">
//       <LogsTable loginLogs={loginLogs} pageCount={pageCount} changePage={changePage} />
//     </div>
//   );
// };

// export default AdminLogs;



import React, { useEffect, useState } from 'react';
import { postAsync } from '../../components/helper/axiosHelper';
import LogsTable from './LogsTable';

const AdminLogs = () => {
  const [loginLogs, setLoginLogs] = useState([]);

  const [pageCount, setPageCount] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 10,
  });
  const [next, setNext] = useState(1);






  // Get Data From LocalStorage
  const EPUserId = localStorage.getItem('apid');

  useEffect(() => {
    (async () => {
      const response = await postAsync(`Admin/GetLoginLogFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`, {}, 'application/json')
      setLoginLogs(response?.data);
      setPageCount(response.page);
      setNext(1);
    })();
  }, []);


  const changePage = async ({ selected }) => {
    const newPage = selected + 1;
    setNext(selected + 1);

    try {
      const response = await postAsync(`Admin/GetLoginLogFilterList/${newPage}/${pageOptions.pageSize}`, {}, 'application/json')
      setLoginLogs(response?.data);
      setPageCount(response.page);
      setNext(1);
    } catch (err) {
      console.log(err);
      toast.error(`${t('msg_errorDueto')}: ${err.message}`);
    }
  };


  return (
    <div className=" ">
      <LogsTable isAdmin={true} loginLogs={ loginLogs } changePage={ changePage } setPageOptions={ setPageOptions } pageOptions={ pageOptions } setPageCount={ setPageCount } pageCount={ pageCount } />
    </div>
  );
};

export default AdminLogs;

